import { Box, Grid, Grid2, Typography } from '@mui/material';
import { TermsAndConditions } from 'components/TermsAndCondition/TermsAndConditions';
import React from 'react';
import { isTablet, isBrowser } from 'react-device-detect';
interface FooterProp {
  bookingScreenTime: number;
}

export const Footer: React.FC<FooterProp> = ({ bookingScreenTime }) => {
  const [dateTime, setDateTime] = React.useState<string>('');
  const [isOpenTermsAndCondition, setIsOpenTermsAndCondition] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    const formatDateTime = () => {
      const now = new Date();
      const day = now.toLocaleString('en-US', { weekday: 'short' });
      const date = now.getDate();
      const month = now.toLocaleString('en-US', { month: 'short' });
      const year = now.getFullYear();
      const time = now.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
      return `${day} ${date} ${month} ${year} | ${time}`;
    };

    setDateTime(formatDateTime());

    const interval = setInterval(() => {
      setDateTime(formatDateTime());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`;
  };

  const popupHandler = (isOpenStatus: boolean) => {
    setIsOpenTermsAndCondition(isOpenStatus);
  };

  return isOpenTermsAndCondition ? (
    <TermsAndConditions
      isOpen={isOpenTermsAndCondition}
      popupHandler={popupHandler}
    />
  ) : (
    <Box
      sx={{
        height: 'auto',
        minHeight: '100px',
        maxHeight: '100px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '90%',
        margin: 'auto',
        padding: '20px 0px',
      }}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Typography
            variant="body1"
            sx={{
              color: '#FFFFFFCC',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              textAlign: 'center',
            }}
          >
            By continuing, you agree to our{' '}
            <a
              style={{
                color: '#FFFFFFCC',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
              onClick={() => popupHandler(!isOpenTermsAndCondition)}
            >
              Terms & Conditions
            </a>
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 container sx={{ marginTop: '20px' }}>
        <Grid2 size={6}>
          {' '}
          <Typography
            variant="body1"
            sx={{
              color: '#FFFFFFCC',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              textAlign: 'left',
            }}
          >
            {dateTime}
            {` | Booking Timeout ${formatTime(bookingScreenTime)}`}
          </Typography>
        </Grid2>
        <Grid2 size={6}>
          <Typography
            variant="body1"
            sx={{
              color: '#FFFFFFCC',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              textAlign: 'right',
            }}
          >
            ©{new Date().getFullYear()} Thrifty Car Rental UAE.
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};
